module.exports = __webpack_public_path__ + "img/logo_skt_round.76e24286.svg";